export default {
	ASSET_LIST_ID: 'search-assets',
	CLIP_LIST_ID: 'search-clips',
	SEARCH_ADVANCED_ID: 'search-advanced',
	SEARCH_BASIC_ID: 'search-basic',
	SEARCH_CLIP_HEADER_ID: 'search-clips-header',
	SEARCH_HEADER_ID: 'search-header',
	SAVED_SEARCH_ID: 'search-saved',
	/**
	 * Route component for showing the contents a saved search
	 * @const
	 * @type {string}
	 * @default
	 */
	ROUTE_SAVED_SEARCH: 'search/saved',
};
